<template>
  <ResidentialFloorDetail
    v-if="this.selectedData && this.selectedData?.floor !== null && this.selectedData?.floor !== undefined"
    :goBack="this.resetSelected"
    :activeData="this.selectedData"
    :params="this.filters"
    :updateData="this.onFLoorSchemaUpdated"
  />
  <div v-else class="wrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <PageTitle>Выберите проект</PageTitle>
    </div>
    <div style="display: flex; width: 100%">
      <div style="width: 100%;">
        <div class="header">
          <Filters
            v-if="!this.fetchingFilters"
            :filters="this.filters"
            :onChange="this.onFiltersChange"
            :needsUpdate="this.needsUpdate"
            :onUpdateSelectedData="this.onUpdateSelectedData"
            @preorderCodeChecked="this.onPreorderCodeChecked"
          />
          <div
            v-if="!!this.selectedData?.entrance_full_name"
            class="entranceFullName"
          >
          <span style="margin-right: 10px;">
              <b>ID проекта - </b>
              {{ `${this.selectedData?.project_id} ` }}</span
            >
            <span
              ><b>Подъезд - </b>
              {{ `${this.selectedData?.entrance} (${this.selectedData?.entrance_percent || 0}%), ` }}</span
            >
            <span
              ><b>Блок -</b> {{ this.selectedData?.block_name || '' }},
            </span>
            <span
              ><b>Подрядчик - </b>
              {{ this.selectedData?.contractor_name || '' }}</span
            >
            <div
              v-if="sessionProjectAssigns.length"
              class="session-assigns tw-mt-2"
            >
              <b>Ваши назначения в проекте:</b>
              {{ sessionProjectAssigns.map((a) => a.assign_type_name).filter(Boolean).join(', ') }}
            </div>
          </div>
          <NotFoundText
            v-if="this.showNotFoundText"
            :text="this.notFoundTextContent"
          />
          <div v-if="showProjectHistory" class="project-history">
            <div
              class="project-history__header"
              role="button"
              tabindex="0"
              @click="toggleProjectHistory"
              @keydown.enter.prevent="toggleProjectHistory"
              @keydown.space.prevent="toggleProjectHistory"
            >
              <span class="project-history__title">История поиска</span>
              <q-icon
                :name="isProjectHistoryExpanded ? 'expand_less' : 'expand_more'"
                size="sm"
                color="grey-7"
              />
            </div>
            <div v-show="isProjectHistoryExpanded" class="project-history__list">
              <div
                v-for="item in projectHistory"
                :key="item.id"
                class="project-history__card"
                @click="applyHistoryItem(item)"
              >
                <div class="project-history__card-name">ID:{{ item.project_id }}, {{ item.resident_name }}</div>
                <div class="project-history__card-type">{{ item.project_type_name }}</div>
                <div class="project-history__card-entrance">
                  Подъезд {{ item.entrance }}<span v-if="item.block_name">, Блок {{ item.block_name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="(this.filters.project_entrance_id || this.showMaterialTabForPreorder || this.tab === 'M__ProjectFormGeodesistCallTab') && !this.isFetching"
          style="margin-top: 20px;"
        >
          <CustomTabs
            :tab="tab"
            :data="this.tabsList"
            label-option="grant_name"
            name-option="grant_code"
            @change_tab="this.onTabChange"
            :paddingless="false"
          >
            <template v-slot:default="item">
              <component
                :is="residentSettingsBlockNames[item.data?.grant_code]"
                :data="item.data?.data"
                :projectId="this.projectId"
                :selectedItems="this.getSelectedFloors()"
                :onApartmentClick="this.onUpdateSelectedData"
                :floorsPlan="this.floorsPlan"
                :isSbs="this.isSbs"
                :getFloorData="this.getFloorData"
                :updateData="this.onFloorsPlanUpdate"
                :showCheckbox="this.tab === 'M__ProjectFormDocumentTab'"
                :tab="this.tab"
                :activeData="this.selectedData"
                :params="item.data?.grant_code === 'M__ProjectFormMaterialTab' && this.showMaterialTabForPreorder ? { ...this.materialTabParams, project_entrance_id: this.filters.project_entrance_id, project_id: this.filters.project_id } : { ...this.filters, project_type_name: this.selectedData?.project_type_name || '' }"
                :onGoToDocumentTab="this.onGoToDocumentTab"
                :initialFloorMapDocumentTypeId="documentTypeIdFromQuery"
              />
            </template>
          </CustomTabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTabs from "@/components/common/CustomTabs";
import PageTitle from "@/components/common/PageTitle.vue";
import CustomSelect from "@/components/form/CustomSelect";
import EntranceDocuments from './Documents.vue';
import EntranceSchema from './EntranceSchema.vue';
import Filters from './filters.vue';
import MaterialRequests from './MaterialRequests.vue';
import MaterialRealizes from './MaterialRealizes.vue';
import ResidentialPayments from './Payments.vue';
import ResidentialApartmentsList from './ResidentialApartmentsList.vue';
import ResidentialEntranceWorkSets from './ResidentialEntranceWorkSets.vue';
import ResidentialFloorDetail from './ResidentialFloorDetail.vue';
import ResidentInfo from './ResidentialInfo.vue';
import { getEntranceApartments, getFloorTabs, getIsProjectSBS, getIsShowAllTab, getSessionProjectAssigns, residentSettingsBlockNames, getFloorMapHeaderInfo } from './services';
import Stages from './Stages.vue';
import Certificates from './Certificates.vue';
import NotFoundText from "@/components/common/NotFoundText.vue";
import Reconciliation from "./Reconciliation.vue";
import GeodesistCallsBlock from "./GeodesistCallsBlock.vue";
import ProjectSmetaTabs from '@/views/ProjectsEntry/components/ProjectSmetaTabs.vue';
import { mapState } from 'pinia'
import { useAppStore } from '@/services/store/app'

const HISTORY_STORAGE_KEY_PREFIX = 'residential_settings_history'
const MAX_HISTORY_ITEMS = 5

export default {
  name: 'ResidentialSettings',
  components: {
    ResidentialApartmentsList, ResidentialFloorDetail, CustomSelect, CustomTabs, EntranceSchema,
    ResidentInfo, ResidentialEntranceWorkSets, MaterialRequests, MaterialRealizes, ResidentialPayments, Filters, Stages, Certificates, EntranceDocuments, PageTitle, NotFoundText,
    Reconciliation, ProjectSmetaTabs, GeodesistCallsBlock
  },
  data() {
    return {
      residentSettingsBlockNames,
      selectedData: null,
      urlNames: null,
      isFetching: false,
      loading: false,
      needsUpdate: true,
      isSbs: false,
      fetchingFilters: true,
      tab: '',
      tabs: [],
      projectId: '',
      floorsPlan: [],
      floorParamData: [],
      filters: {
        resident_id: '',
        project_type_id: '',
        project_entrance_id: '',
        sbs_project_id: null,
      },
      showMaterialTabForPreorder: false,
      materialTabParams: null,
      projectHistory: [],
      isProjectHistoryExpanded: true,
      sessionProjectAssigns: [],
    };
  },
  computed: {
    ...mapState(useAppStore, ['userData']),
    historyStorageKey() {
      const id = this.userData?.employee_id
      if (id != null && id !== '') {
        return `${HISTORY_STORAGE_KEY_PREFIX}_user_${id}`
      }
      return `${HISTORY_STORAGE_KEY_PREFIX}_anonymous`
    },
    tabsList() {
      // Редирект с /geodesist-calls: показываем только вкладку "Вызовы геодезиста"
      if (this.tab === 'M__ProjectFormGeodesistCallTab' && !this.filters.project_entrance_id && !this.showMaterialTabForPreorder) {
        return [{ grant_code: 'M__ProjectFormGeodesistCallTab', grant_name: 'Вызовы геодезиста' }];
      }
      // Если выбраны ЖК и тип проекта без подъезда - показываем только Материалы
      if (!this.filters.project_entrance_id && this.filters.resident_id && this.filters.project_type_id && this.showMaterialTabForPreorder) {
        return [{ grant_code: 'M__ProjectFormMaterialTab', grant_name: 'Материалы' }];
      }
      
      // Если выбран подъезд и is_show_all_tab = false - показываем только Материалы
      if (this.filters.project_entrance_id && this.showMaterialTabForPreorder) {
        return [{ grant_code: 'M__ProjectFormMaterialTab', grant_name: 'Материалы' }];
      }
      
      // Если выбран подъезд и is_show_all_tab = true - показываем все вкладки
      if (!this.tabs?.length) return []
      const baseTabs = [
        this.tabs[0],
        { grant_code: 'EntranceSchema', grant_name: 'Схема этажа' },
        ...this.tabs.slice(1),
      ];
      baseTabs.push({ grant_code: 'M__ProjectFormMaterialRealizeTab', grant_name: 'Реализации' });
      return baseTabs.map(t =>
        t?.grant_code === 'M__ProjectFormSmetaTab'
          ? { ...t, grant_name: 'Смета' }
          : t
      )
    },
    showNotFoundText() {
      // Вкладка "Вызовы геодезиста" или подъезд или ЖК+тип (Материалы) - не показываем "Не найдено"
      if (this.tab === 'M__ProjectFormGeodesistCallTab' || this.filters?.project_entrance_id || (this.filters?.resident_id && this.filters?.project_type_id && this.showMaterialTabForPreorder)) {
        if (this.tabsList?.length) return false
      }
      return true
    },
    notFoundTextContent() {
      if(this.isFetching) return 'Загрузка...'
      if(this.filters?.project_entrance_id) {
        if(this.tabsList?.length) return null
        return 'Нет данных'
      }
      return 'Заполните данные'
    },
    documentTypeIdFromQuery() {
      const id = this.$route.query.floor_map_document_type_id
      return id != null && id !== '' ? Number(id) : null
    },
    showProjectHistory() {
      return this.showNotFoundText && this.notFoundTextContent === 'Заполните данные' && this.projectHistory.length > 0
    }
  },
  methods: {
    toggleProjectHistory() {
      this.isProjectHistoryExpanded = !this.isProjectHistoryExpanded
    },
    initFiltersFromRoute() {
      this.fetchingFilters = true
      const { resident_id, project_type_id, project_entrance_id, project_id, sbs_project_id, tab, floor, floor_map_id, flat_id } = this.$route.query
      this.filters = {
        resident_id: resident_id ? Number(resident_id) : null,
        project_type_id: project_type_id ? Number(project_type_id) : null,
        project_entrance_id: project_entrance_id ? Number(project_entrance_id) : null,
        project_id: project_id ? Number(project_id) : null,
        sbs_project_id: sbs_project_id != null && sbs_project_id !== '' ? Number(sbs_project_id) : null
      }
      this.projectId = project_id || ''

      if(tab) {
        const isTabValid = !!this.residentSettingsBlockNames[tab]
        if(isTabValid)
          this.tab = tab || ''
      }

      // Восстанавливаем выбранный этаж из URL
      if (floor && floor_map_id) {
        this.selectedData = {
          floor: Number(floor),
          floor_map_id: Number(floor_map_id),
          flat_id: flat_id ? Number(flat_id) : null
        }
        // Устанавливаем флаг для обновления данных резидента и подъезда через filters
        this.needsUpdate = true
      }

      if (project_entrance_id) {
        this.getIsSBS()
        this.getFloorsPlan()
        // Всегда проверяем is_show_all_tab при инициализации
        // Если project_id нет в URL, получим его из данных подъезда после загрузки
        if (this.filters.project_id) {
          this.checkIsShowAllTabAndLoadTabs(this.filters.project_id)
        } else {
          // Если project_id нет, получим его из данных подъезда после загрузки filters
          // Проверка будет вызвана в onUpdateSelectedData когда загрузятся данные подъезда
        }
      }
      this.fetchingFilters = false
    },
    onTabChange(tab) {
      this.tab = tab
      this.$router.replace({ query: { ...this.$route.query, tab }})
    },
    onGoToDocumentTab(row) {
      if (!row?.resident_id || !row?.project_type_id || !row?.project_entrance_id) return
      this.filters.resident_id = row.resident_id
      this.filters.project_type_id = row.project_type_id
      this.filters.project_entrance_id = row.project_entrance_id
      if (row.project_id != null) {
        this.filters.project_id = row.project_id
        this.projectId = row.project_id
        this.loadSessionProjectAssigns(row.project_id)
      }
      if (row.sbs_project_id != null) this.filters.sbs_project_id = row.sbs_project_id
      this.tab = 'M__ProjectFormDocumentTab'
      const query = { ...this.$route.query, tab: this.tab }
      if (row.floor_map_document_type_id != null && row.floor_map_document_type_id !== '') {
        query.floor_map_document_type_id = row.floor_map_document_type_id
      }
      this.$router.replace({ query })
    },
    async getIsSBS() {
      if(!this.projectId) return
      const res = await getIsProjectSBS(this.projectId);
      this.isSbs = !!res?.is_sbs;
    },
    getFloorData(floor = '') {
      if (!this.floorParamData?.length) return ''
      const data = this.floorParamData?.find(item => item.floor === floor)
      if (!data) return ''
      return data?.param_value || ''
    },
    async getFloorsPlan() {
      if (!this.filters.project_entrance_id) {
        this.floorsPlan = null
        this.floorParamData = null
        return
      }
      this.isFetching = true
      const res = await getEntranceApartments(this.filters)
      this.isFetching = false
      this.floorsPlan = res?.data || []
      
      // Если есть выбранный этаж из URL, дополняем его данными
      if (this.selectedData?.floor !== null && this.selectedData?.floor !== undefined) {
        this.enrichSelectedDataFromFloorsPlan()
      }
    },
    getSelectedFloors() {
      return this.floorsPlan?.filter(item => item.is_selected)?.map(item => item.floor_map_id) || []
    },
    async getTabs() {
      if (this.tabs?.length) return
      const res = await getFloorTabs()
      if (!res?.length) return
      this.tabs = res || []

      if(!this.tab) {
        this.tab = res[0].grant_code
        this.$router.replace({ query: { ...this.$route.query, tab: this.tab }})
      }
    },
    onFiltersChange(key, value, row) {
      this.filters[key] = value
      if (!!row) {
        // Обновляем selectedData данными из фильтров
        this.selectedData = this.selectedData ? { ...this.selectedData, ...row } : { ...row }
      }

      if (key === 'resident_id') {
        const hadProjectType = this.filters.project_type_id
        this.filters = {
          resident_id: value,
          ...(row?.sbs_project_id != null && { sbs_project_id: row.sbs_project_id }),
        }
        this.projectId = ''
        this.sessionProjectAssigns = []
        this.floorsPlan = null
        this.floorParamData = null
        if (this.selectedData)
          this.selectedData.entrance_full_name = null
        if (!value) {
          this.selectedData = null
          this.showMaterialTabForPreorder = false
          this.materialTabParams = null
        } else if (hadProjectType) {
          this.showMaterialTabForPreorder = true
          this.materialTabParams = {
            resident_id: value,
            project_type_id: hadProjectType,
            sbs_project_id: row?.sbs_project_id,
          }
        }
      }
      if (key === 'project_type_id') {
        this.filters.project_entrance_id = ''
        this.projectId = ''
        this.sessionProjectAssigns = []
        this.floorsPlan = null
        this.floorParamData = null
        this.showMaterialTabForPreorder = false
        this.materialTabParams = null
        if (this.selectedData)
          this.selectedData.entrance_full_name = null
        if (value && this.filters.resident_id) {
          this.showMaterialTabForPreorder = true
          this.materialTabParams = {
            resident_id: this.filters.resident_id,
            project_type_id: value,
            sbs_project_id: this.filters.sbs_project_id,
          }
        }
      }
      if (key === 'resident_id') {
        this.showMaterialTabForPreorder = false
        this.materialTabParams = null
        if (value && this.filters.project_type_id) {
          this.showMaterialTabForPreorder = true
          this.materialTabParams = {
            resident_id: value,
            project_type_id: this.filters.project_type_id,
            sbs_project_id: row?.sbs_project_id,
          }
        }
      }
      if (key === 'project_entrance_id') {
        this.floorParamData = null
        this.projectId = row?.project_id
        if (row?.project_id) {
          this.filters.project_id = row.project_id
        }
        if (this.selectedData && !value)
          this.selectedData.entrance_full_name = null
        if (!value) {
          this.sessionProjectAssigns = []
        }
        this.getIsSBS()
        this.getFloorsPlan()
        if (value) {
          this.saveToHistory()
          const projectId = row?.project_id || this.filters.project_id
          if (projectId) {
            this.checkIsShowAllTabAndLoadTabs(projectId)
          }
        } else if (!value) {
          // Если подъезд сброшен, сбрасываем вкладки
          this.tabs = []
          this.showMaterialTabForPreorder = false
          this.materialTabParams = null
        }
      }
    },
    onUpdateSelectedData(data) {
      if(!data) return
      this.selectedData = { ...this.selectedData, ...data }
      // Если project_id получен из данных подъезда и еще не был установлен, устанавливаем его
      if (data.project_id != null && this.filters.project_entrance_id) {
        if (!this.filters.project_id) {
          this.filters.project_id = data.project_id
          this.projectId = data.project_id
        }
        // Всегда проверяем is_show_all_tab когда есть project_id и выбран подъезд
        if (this.filters.project_id) {
          this.checkIsShowAllTabAndLoadTabs(this.filters.project_id)
        }
      }
      // Обновляем URL при выборе этажа
      if (data.floor !== undefined && data.floor_map_id) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            floor: data.floor,
            floor_map_id: data.floor_map_id,
            flat_id: data.flat_id || undefined
          }
        })
      }
    },
    onFLoorSchemaUpdated() {
      this.getFloorsPlan()
    },
    onFloorsPlanUpdate(res) {
      this.floorsPlan = res
    },
    enrichSelectedDataFromFloorsPlan() {
      // Дополняем selectedData информацией из floorsPlan
      const floorData = this.floorsPlan?.find(
        floor => floor.floor === this.selectedData.floor && floor.floor_map_id === this.selectedData.floor_map_id
      )
      
      if (floorData) {
        // Находим данные квартиры, если есть flat_id
        let flatData = null
        if (this.selectedData.flat_id) {
          flatData = floorData.flat?.find(flat => flat.flat_id === this.selectedData.flat_id)
        }
        
        // Объединяем все данные
        this.selectedData = {
          ...this.selectedData,
          ...floorData,
          ...(flatData || {}),
          // Сохраняем оригинальные значения floor и floor_map_id
          floor: this.selectedData.floor,
          floor_map_id: this.selectedData.floor_map_id,
          flat_id: this.selectedData.flat_id
        }
      }
    },
    async loadEntranceDataForFloor() {
      // Загружаем данные о подъезде для восстановления информации в шапке
      if (!this.selectedData?.floor_map_id) return
      
      try {
        const headerData = await getFloorMapHeaderInfo(this.selectedData.floor_map_id)
        if (headerData) {
          this.selectedData = { ...this.selectedData, ...headerData }
        }
      } catch (error) {
        console.error('Error loading floor map header data:', error)
      }
    },
    resetSelected() {
      this.selectedData = { ...this.selectedData, floor: null, flat_id: null, floor_map_id: null }
      this.needsUpdate = false
      
      // Убираем параметры этажа из URL при возврате
      const query = { ...this.$route.query }
      delete query.floor
      delete query.floor_map_id
      delete query.flat_id
      this.$router.replace({ query })
      
      // При возврате из схемы этажа, если выбран подъезд, всегда проверяем is_show_all_tab
      if (this.filters.project_entrance_id && this.filters.project_id) {
        this.checkIsShowAllTabAndLoadTabs(this.filters.project_id)
      }
    },
    onPreorderCodeChecked(data) {
      this.showMaterialTabForPreorder = !!data?.showMaterialTab
      this.materialTabParams = data?.params ?? null
      if (data?.params?.sbs_project_id != null) {
        this.filters.sbs_project_id = data.params.sbs_project_id
      }
      if (data?.showMaterialTab) {
        if (!this.tab || this.tab !== 'M__ProjectFormMaterialTab') {
          this.tab = 'M__ProjectFormMaterialTab'
          this.$router.replace({ query: { ...this.$route.query, tab: this.tab }})
        }
      }
    },
    loadProjectHistory() {
      try {
        return JSON.parse(localStorage.getItem(this.historyStorageKey) || '[]')
      } catch {
        return []
      }
    },
    saveToHistory() {
      if (!this.userData?.employee_id) return
      if (!this.filters.resident_id || !this.filters.project_type_id || !this.filters.project_entrance_id) return

      const historyItem = {
        id: `${this.filters.resident_id}_${this.filters.project_type_id}_${this.filters.project_entrance_id}`,
        resident_id: this.filters.resident_id,
        project_type_id: this.filters.project_type_id,
        project_entrance_id: this.filters.project_entrance_id,
        project_id: this.filters.project_id || this.projectId,
        sbs_project_id: this.filters.sbs_project_id,
        resident_name: this.selectedData?.resident_name || '',
        project_type_name: this.selectedData?.project_type_name || '',
        entrance: this.selectedData?.entrance || '',
        block_name: this.selectedData?.block_name || '',
        timestamp: Date.now()
      }

      let history = this.projectHistory.filter(item => item.id !== historyItem.id)
      history.unshift(historyItem)
      history = history.slice(0, MAX_HISTORY_ITEMS)

      try {
        localStorage.setItem(this.historyStorageKey, JSON.stringify(history))
      } catch {}

      this.projectHistory = history
    },
    async applyHistoryItem(item) {
      this.fetchingFilters = true
      this.filters = {
        resident_id: item.resident_id,
        project_type_id: item.project_type_id,
        project_entrance_id: item.project_entrance_id,
        project_id: item.project_id,
        sbs_project_id: item.sbs_project_id || null,
      }
      this.projectId = item.project_id || ''
      this.needsUpdate = true
      this.selectedData = null
      this.showMaterialTabForPreorder = false
      this.materialTabParams = null

      await this.$nextTick()
      this.fetchingFilters = false

      this.getIsSBS()
      this.getFloorsPlan()
      if (item.project_id) {
        this.checkIsShowAllTabAndLoadTabs(item.project_id)
      }
    },
    async loadSessionProjectAssigns(project_id) {
      if (project_id == null) return
      const rows = await getSessionProjectAssigns(project_id)
      this.sessionProjectAssigns = Array.isArray(rows) ? rows : []
    },
    async checkIsShowAllTabAndLoadTabs(project_id) {
      if (project_id == null) return
      await this.loadSessionProjectAssigns(project_id)
      const isShowAllTab = await getIsShowAllTab({ project_id })
      if (isShowAllTab) {
        this.showMaterialTabForPreorder = false
        await this.getTabs()
        if (!this.tab && this.tabs?.length) {
          this.tab = this.tabs[0].grant_code
          this.$router.replace({ query: { ...this.$route.query, tab: this.tab }})
        }
      } else {
        this.showMaterialTabForPreorder = true
        this.tabs = []
        this.materialTabParams = {
          ...this.materialTabParams,
          project_id,
          project_entrance_id: this.filters.project_entrance_id,
          resident_id: this.filters.resident_id,
          project_type_id: this.filters.project_type_id,
          sbs_project_id: this.filters.sbs_project_id,
        }
        if (!this.tab || this.tab !== 'M__ProjectFormMaterialTab') {
          this.tab = 'M__ProjectFormMaterialTab'
          this.$router.replace({ query: { ...this.$route.query, tab: this.tab }})
        }
      }
    },
  },
  watch: {
    historyStorageKey: {
      immediate: true,
      handler() {
        this.projectHistory = this.loadProjectHistory()
      },
    },
    filters: {
      deep: true,
      handler(newVal) {
        const { floor, floor_map_id, flat_id, floor_map_document_type_id } = this.$route.query
        this.$router.replace({
          query: {
            ...this.$route.query,
            resident_id: newVal.resident_id,
            project_type_id: newVal.project_type_id,
            project_entrance_id: newVal.project_entrance_id,
            project_id: this.projectId,
            ...(newVal.sbs_project_id != null && { sbs_project_id: newVal.sbs_project_id }),
            tab: this.tab,
            floor: floor || undefined,
            floor_map_id: floor_map_id || undefined,
            flat_id: flat_id || undefined,
            floor_map_document_type_id: floor_map_document_type_id || undefined,
          }
        })
      }
    }
  },
  async mounted() {
    this.initFiltersFromRoute()
    
    if (this.selectedData?.floor !== null && this.selectedData?.floor !== undefined) {
      await this.loadEntranceDataForFloor()
    }
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding-top: 20px;
  position: relative;
}

.header {
  padding: 0 20px;

  @media (max-width: 991px) {
    width: 100%;
  }
}

.filters {
  display: flex;
  align-items: flex-end;
  gap: 15px;
}

.filters__item {
  width: 240px;
}

.entranceFullName {
  color: #404040;
  font-size: 13px;
  margin-top: 10px;
}

.project-history {
  margin-top: 24px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    margin-bottom: 12px;
    padding: 4px 0;
    border-radius: 4px;
    outline: none;

    &:hover {
      opacity: 0.85;
    }

    &:focus-visible {
      box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.35);
    }
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #666;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  &__card {
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s;
    min-width: 200px;
    max-width: 280px;
    background: #fff;

    &:hover {
      border-color: var(--q-primary);
      box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
    }

    &-name {
      font-weight: 600;
      font-size: 14px;
      color: #333;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-type {
      font-size: 13px;
      color: #666;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-entrance {
      font-size: 12px;
      color: #999;
    }

    &-id {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }
}
</style>
